import { useSelector } from "react-redux";
import { getCategoryChildLinks } from "../../../../../../../state/modules/category";
import TextCategoryHeaderLinks from "./TextCategoryHeaderLinks";

const ConnectedTextCategoryHeaderLinks = props => {
  const childLinks = useSelector(getCategoryChildLinks);

  return <TextCategoryHeaderLinks {...props} childLinks={childLinks} />;
};

export default ConnectedTextCategoryHeaderLinks;
